/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type CartItems_portfolioItems$ref = any;
export type CartLayout_portfolioItems$ref = any;
export type CartLayout_portfolioItems = {
    readonly totalResults: number | null;
    readonly pageInfo: {
        readonly hasNextPage: boolean;
    };
    readonly edges: ReadonlyArray<{
        readonly node: {
            readonly item: {
                readonly categoryPath: string | null;
            } | null;
        } | null;
    } | null> | null;
    readonly " $fragmentRefs": CartItems_portfolioItems$ref;
    readonly " $refType": CartLayout_portfolioItems$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "CartLayout_portfolioItems",
    "type": "PortfolioItemsConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "totalResults",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "pageInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "PageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasNextPage",
                    "args": null,
                    "storageKey": null
                }
            ]
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "PortfolioItemsEdge",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PortfolioItemV2",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "item",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Item",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "categoryPath",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "CartItems_portfolioItems",
            "args": null
        }
    ]
} as any);
(node as any).hash = '1d476664870487dc38b0f5cbe12a6b2c';
export default node;
